
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"24","width":"24","id":"Pencil-Write-2--Streamline-Streamline--3.0.svg"}, attrs),
              ...rest,
            },
            children.concat([_c('desc',[_v('Pencil Write 2 Streamline Icon: https://streamlinehq.com')]),_c('defs'),_c('title',[_v('pencil-write-2')]),_c('path',{attrs:{"d":"m12.667 14.136 -3.712 0.531 0.53 -3.713 9.546 -9.546a2.25 2.25 0 0 1 3.182 3.182Z","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M19.122 14.25v7.5a1.5 1.5 0 0 1 -1.5 1.5h-15a1.5 1.5 0 0 1 -1.5 -1.5v-15a1.5 1.5 0 0 1 1.5 -1.5h7.5","fill":"none","stroke":"currentcolor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    